// extracted by mini-css-extract-plugin
module.exports = {"root":"Header-module--root--1SPn1","content":"Header-module--content--3nA-z"};